import Products from 'merchandise-lib/constants/Product';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';

// This is used to submit product_upgrade_interest to 53
// If a new value is added here, make a request in HelpSpot under '53 Systems and Data'
// Category: Property Updates and Data Quality
// Subcategory: Product Update
// Property internal name: product_upgrade_interest
export const productUpgradeInterest = {
  [UpgradeProducts.SALES_PRO]: 'Sales-Pro',
  [UpgradeProducts.SALES_STARTER]: 'Sales-Starter',
  [UpgradeProducts.SALES_PROFESSIONAL]: 'Sales-Professional',
  [UpgradeProducts.SALES_ENTERPRISE]: 'Sales-Enterprise',
  [UpgradeProducts.SALES_FREE]: 'Sales-Free',
  [UpgradeProducts.MARKETING_FREE]: 'Marketing-Free',
  [UpgradeProducts.MARKETING_STARTER]: 'Marketing-Starter',
  [UpgradeProducts.MARKETING_STARTER_EMAIL]: 'Marketing-Starter',
  [UpgradeProducts.MARKETING_BASIC]: 'Marketing-Basic',
  [UpgradeProducts.MARKETING_PRO]: 'Marketing-Pro',
  [UpgradeProducts.MARKETING_ENTERPRISE]: 'Marketing-Ent',
  [UpgradeProducts.SERVICE_FREE]: 'Service-Free',
  [UpgradeProducts.SERVICE_STARTER]: 'Service-Starter',
  [UpgradeProducts.SERVICE_PROFESSIONAL]: 'Service-Professional',
  [UpgradeProducts.SERVICE_ENTERPRISE]: 'Service-Enterprise',
  [UpgradeProducts.STARTER_CONTACTS]: 'Starter-Contacts',
  [UpgradeProducts.CMS_STARTER]: 'CMS-Starter',
  [UpgradeProducts.CMS_PROFESSIONAL]: 'CMS-Professional',
  [UpgradeProducts.CMS_ENTERPRISE]: 'CMS-Enterprise',
  [UpgradeProducts.ADS]: 'Marketing-Ads',
  [UpgradeProducts.ADS_CAPACITY]: 'Ads-Capacity',
  [UpgradeProducts.WEBSITE]: 'Marketing-Website',
  [UpgradeProducts.REPORTING]: 'reporting',
  [UpgradeProducts.DEDICATED_IP]: 'Marketing-Dedicated IP',
  [UpgradeProducts.ADDITIONAL_ACCOUNT]: 'Marketing-Additional Portal',
  [UpgradeProducts.DESIGNATED_TECHNICAL_SUPPORT]: 'Designated-Technical-Support',
  [UpgradeProducts.IN_PERSON_TRAINING]: 'Training-In-Person',
  [UpgradeProducts.SALES_PROFESSIONAL_ONBOARDING]: 'Sales Professional Onboarding',
  [UpgradeProducts.SERVICE_PROFESSIONAL_ONBOARDING]: 'Service Professional Onboarding',
  [UpgradeProducts.INBOUND_CONSULTING_BLOCK]: 'Inbound Consulting Block',
  [UpgradeProducts.TECHNICAL_CONSULTING_BLOCK]: 'Technical Consulting Block',
  [UpgradeProducts.ENTERPRISE]: 'Enterprise',
  [UpgradeProducts.PARTNER_PROGRAM]: 'Partner-Program',
  [UpgradeProducts.SUITE_STARTER]: 'Starter Suite',
  [UpgradeProducts.SUITE_PROFESSIONAL]: 'Professional Suite',
  [UpgradeProducts.SUITE_ENTERPRISE]: 'Enterprise Suite',
  [UpgradeProducts.BUNDLE]: 'Bundle',
  [UpgradeProducts.OPERATIONS_STARTER]: 'Operations-Starter',
  [UpgradeProducts.OPERATIONS_PROFESSIONAL]: 'Operations-Professional',
  [UpgradeProducts.OPERATIONS_ENTERPRISE]: 'Operations-Enterprise',
  [UpgradeProducts.CUSTOM_SSL]: 'Custom-SSL',
  [UpgradeProducts.WORKFLOWS_ADDON]: 'Workflows-Addon',
  [UpgradeProducts.MARKETING_PLUS_PROFESSIONAL]: 'marketing-plus-professional-bundle',
  [UpgradeProducts.MARKETING_PLUS_ENTERPRISE]: 'marketing-plus-enterprise-bundle',
  [UpgradeProducts.MARKETING_SMS_SHORT_CODE]: 'Marketing-SMS-Short-Code',
  [UpgradeProducts.COMMERCE_PROFESSIONAL]: 'Commerce-Professional',
  [UpgradeProducts.COMMERCE_ENTERPRISE]: 'Commerce-Enterprise',
  //temporary duplicates for apiNames
  [Products.SALES_HUB_STARTER]: 'Sales-Starter',
  [Products.SALES_HUB_PROFESSIONAL]: 'Sales-Professional',
  [Products.SALES_HUB_ENTERPRISE]: 'Sales-Enterprise',
  [FreeProducts.MARKETING_HUB_FREE]: 'Marketing-Free',
  [Products.MARKETING_HUB_STARTER]: 'Marketing-Starter',
  [Products.MARKETING_HUB_BASIC]: 'Marketing-Basic',
  [Products.MARKETING_HUB_PROFESSIONAL]: 'Marketing-Pro',
  [FreeProducts.SERVICE_HUB_FREE]: 'Service-Free',
  [Products.SERVICE_HUB_STARTER]: 'Service-Starter',
  [Products.SERVICE_HUB_PROFESSIONAL]: 'Service-Professional',
  [Products.SERVICE_HUB_ENTERPRISE]: 'Service-Enterprise',
  [Products.CMS_HUB_STARTER]: 'CMS-Starter',
  [Products.CMS_HUB_PROFESSIONAL]: 'CMS-Professional',
  [Products.CMS_HUB_ENTERPRISE]: 'CMS-Enterprise',
  [Products.OPERATIONS_HUB_STARTER]: 'Operations-Starter',
  [Products.OPERATIONS_HUB_PROFESSIONAL]: 'Operations-Professional',
  [Products.OPERATIONS_HUB_ENTERPRISE]: 'Operations-Enterprise',
  [Products.COMMERCE_HUB_PROFESSIONAL]: 'Commerce-Professional',
  [Products.COMMERCE_HUB_ENTERPRISE]: 'Commerce-Enterprise',
  [Products.CRM_SUITE_STARTER_BUNDLE]: 'Starter Suite',
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'Professional Suite',
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: 'Enterprise Suite',
  //probably not used
  // [Products.STARTER_CONTACTS]: 'Starter-Contacts', //apparently replaced with STARTER_MARKETING_CONTACTS
  // [Products.DESIGNATED_TECHNICAL_SUPPORT]: 'Designated-Technical-Support', //service
  // [Products.IN_PERSON_TRAINING]: 'Training-In-Person', //service
  // [Products.INBOUND_CONSULTING_BLOCK]: 'Inbound Consulting Block', //pricing page, in use
  // [Products.TECHNICAL_CONSULTING_BLOCK]: 'Technical Consulting Block', //pricing page, in use
  // [Products.PARTNER_PROGRAM]: 'Partner-Program',
  // [Products.ADS_CAPACITY]: 'Ads-Capacity', //replaced by ADS_LIMIT_INCREASE
  // [Products.WEBSITE]: 'Marketing-Website', //was an add-on, probably not used
  // [Products.ADDITIONAL_ACCOUNT]: 'Marketing-Additional Portal', //probably not used

  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: 'Marketing-Dedicated IP',
  [Products.TRANSACTIONAL_EMAIL]: 'Marketing-Transactional Email',
  [Products.BRAND_DOMAIN]: 'Brand-Domain',
  [Products.STARTER_KIT]: 'Starter Kit',
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: 'Sales Professional Onboarding',
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: 'Service Professional Onboarding',
  [Products.MARKETING_HUB_ENTERPRISE]: 'Enterprise',
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: 'Custom-SSL',
  [Products.ADS_LIMIT_INCREASE]: 'Marketing-Ads',
  [Products.REPORTING_LIMIT_INCREASE]: 'reporting',
  [Products.DOMAINS_LIMIT_INCREASE]: 'Domains-Limit-Increase',
  [Products.SANDBOX_LIMIT_INCREASE]: 'Sandbox-Limit-Increase',
  [Products.ESIGNATURE_LIMIT_INCREASE]: 'Esignature-Limit-Increase',
  [Products.WORKFLOWS_LIMIT_INCREASE]: 'Workflows-Addon',
  [Products.CALLING_LIMIT_INCREASE]: 'Calling-Limit-Increase',
  [Products.PHONE_LIMIT_INCREASE]: 'Phone-Limit-Increase',
  [Products.WHATSAPP_LIMIT_INCREASE]: 'Whatsapp-Limit-Increase',
  [Products.VIDEO_LIMIT_INCREASE]: 'Video-Limit-Increase',
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  // hold-overs from upgradeProducts that are needed but don't have an apiName
  ['BUNDLE']: 'Bundle',
  // what the pricing page sends when multiple products are selected

  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: 'marketing-plus-professional-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: 'marketing-plus-enterprise-bundle',
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [Products.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [Products.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [Products.MARKETING_SMS]: 'marketing-sms',
  [Products.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [Products.TEAMS_LIMIT_INCREASE]: 'Teams-Limit-Increase',
  [Products.CORE_SEATS_STARTER]: 'core-seats-starter',
  [Products.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [Products.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise',
  [Products.HUBSPOT_FOR_STARTUPS_SETUP]: 'hubspot-for-startups-setup',
  [Products.HUBSPOT_CREDITS_COMMITTED]: 'hubspot-credits-committed',
  [Products.HUBSPOT_CREDITS_COMMITTED_OVERAGE]: 'hubspot-credits-committed-overage',
  [Products.HUBSPOT_CREDITS_OVERAGE]: 'hubspot-credits-overage'
};